<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card grid-list-md>
      <ModelTitle title="Product & Price" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedProduct"
              hide-no-data
              ref="productSearch"
              outlined
              prepend-inner-icon="search"
              rounded
              auto-select-first
              autofocus
              dense
              :loading="loading"
              single-line
              hide-details
              clearable
              id="productSearch"
              :items="Products"
              item-text="name"
              return-object
              :search-input.sync="phoneSearch"
              label="Select Product"
            >
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="item.trackInventory"
                  :color="
                    item.trackSerialNumber ? 'light-primary' : 'teal darken-1'
                  "
                  dark
                >
                  <v-avatar
                    left
                    class="light-blue darken-2"
                    v-if="item.trackSerialNumber"
                  >
                    <v-icon small>mdi-barcode-scan</v-icon>
                  </v-avatar>
                  <v-avatar left v-else class="teal darken-3">
                    <v-icon small>mdi-package-variant-closed</v-icon>
                  </v-avatar>
                  <span>{{ item.balance }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12">
            <v-text-field
              outlined
              rounded
              dense
              :hide-details="priceErrors.length === 0"
              :error-messages="priceErrors"
              @focus="$event.target.select()"
              class="right-input"
              v-model="CustomerPrice.price"
              label="Price"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import customerPriceService from "@/modules/Customer/CustomerPrice/service.js";
import productService from "@/modules/Product/service";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-customer-price",
  props: ['createDialog', 'CustomerId'],
  data() {
    return {
      loading: false,
      dialog: false,
      phoneSearch: null,
      selectedProduct: null,
      CustomerPrice: {
        price: 0,
        name: null,
        ProductId: null,
      },
      Products: [],
    };
  },
  mixins: [validationMixin],
  validations: {
    CustomerPrice: {
      price: {
        required,
      },
    },
  },
  watch: {
    phoneSearch(val) {
      if (val && val.length > 2) {
        this.getProduct();
      }
    },
    selectedProduct(val) {
      if (val) {
        this.CustomerPrice.ProductId = val.id;
        this.CustomerPrice.price = val.price;
        this.CustomerPrice.name = val.name;
      }
    },
    createDialog(val) {
      this.dialog = val;
      this.selectedProduct = null;
      if(val){
        this.getProduct();
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    priceErrors() {
      const errors = [];
      if (!this.$v.CustomerPrice.price.$dirty) return errors;
      if (!this.$v.CustomerPrice.price.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    getProduct() {
      this.loading = true;
      return productService.getAll({search: this.phoneSearch}).then((result) => {
        this.Products = result.data;
        this.loading = false;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.CustomerPrice = {
        price: 0,
        name: null,
        ProductId: null,
      };
      this.selectedProduct = null;
      this.phoneSearch = null;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.CustomerPrice.CustomerId = this.CustomerId;
        return customerPriceService
          .create(this.CustomerPrice)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Customer Price is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
